import { User } from 'src/app/models/user'
import { coerceToArray } from '../../services/utils'

export class MessageRecipients {
  users: User[]
  title: string

  constructor(users: User | User[], title?: string) {
    this.users = coerceToArray(users)
    if (!title) {
      this.title = this.users.map((u) => u.fullName()).join(', ')
    } else {
      this.title = title
    }
  }
}
